import { useState, useEffect } from "react";
import { AdminLayout } from "@/project/jain_elibrary-admin/components/layout/AdminLayout";
import { StatsCard } from "@/project/jain_elibrary-admin/components/dashboard/StatsCard";
import { adminService, Statistics } from "../services/adminService";

const formatNumber = (value: number | null | undefined): string =>
  value !== null && value !== undefined ? value.toLocaleString() : "—";

const Dashboard = () => {
  const [statistics, setStatistics] = useState<Statistics | null>(null);

  useEffect(() => {
    adminService
      .getStatistics()
      .then(setStatistics)
      .catch(() => {});
  }, []);

  return (
    <AdminLayout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold text-foreground">Dashboard</h2>
            <p className="mt-1 text-sm text-muted-foreground">
              Overview of your library statistics and recent activity
            </p>
          </div>
        </div>

        {/* Core Statistics */}
        <div>
          <h3 className="mb-4 text-lg font-semibold text-foreground">
            Core Statistics
          </h3>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
            <StatsCard
              title="Total Books"
              value={formatNumber(statistics?.total_books)}
              className="border-l-4 border-l-blue-500"
            />
            <StatsCard
              title="Total Users"
              value={formatNumber(statistics?.total_users)}
              className="border-l-4 border-l-green-500"
            />
            <StatsCard
              title="Total Downloads"
              value={formatNumber(statistics?.total_downloads)}
              className="border-l-4 border-l-purple-500"
            />
            <StatsCard
              title="Total Donations"
              value={formatNumber(statistics?.total_donations)}
              className="border-l-4 border-l-red-500"
            />
          </div>
        </div>

        {/* Content Statistics */}
        <div>
          <h3 className="mb-4 text-lg font-semibold text-foreground">
            Content Statistics
          </h3>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
            <StatsCard
              title="Articles"
              value={formatNumber(statistics?.total_articles)}
            />
            <StatsCard
              title="Audio Files"
              value={formatNumber(statistics?.total_audio)}
            />
            <StatsCard
              title="Manuscripts"
              value={formatNumber(statistics?.total_manuscripts)}
            />
            <StatsCard
              title="Agam"
              value={formatNumber(statistics?.total_agam)}
            />
          </div>
        </div>

        {/* Library Statistics */}
        <div>
          <h3 className="mb-4 text-lg font-semibold text-foreground">
            Library Statistics
          </h3>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
            <StatsCard
              title="Authors"
              value={formatNumber(statistics?.total_authors)}
            />
            <StatsCard
              title="Publishers"
              value={formatNumber(statistics?.total_publishers)}
            />
            <StatsCard
              title="Catalogues"
              value={formatNumber(statistics?.total_catalogues)}
            />
            <StatsCard
              title="Magazines"
              value={formatNumber(statistics?.total_magazines)}
            />
          </div>
        </div>

        {/* Requests & Feedback */}
        <div>
          <h3 className="mb-4 text-lg font-semibold text-foreground">
            Requests & Feedback
          </h3>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            <StatsCard
              title="Upload Requests"
              value={formatNumber(statistics?.total_upload_requests)}
            />
            <StatsCard
              title="Book Requests"
              value={formatNumber(statistics?.total_book_requests)}
            />
            <StatsCard
              title="Feedback"
              value={formatNumber(statistics?.total_feedback)}
            />
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Dashboard;
